import { render, staticRenderFns } from "./view6.vue?vue&type=template&id=05e85aaf&scoped=true"
import script from "./view6.vue?vue&type=script&lang=js"
export * from "./view6.vue?vue&type=script&lang=js"
import style0 from "./view6.vue?vue&type=style&index=0&id=05e85aaf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e85aaf",
  null
  
)

export default component.exports